import React, { Component } from "react";
import "./col-select.css";

class ColSelect extends Component {
	onColumnSelect = e => {
		this.props.onChange(parseInt(e.target.value, 10));
	};

	renderColumnOption = (header, index) => {
		const columnName = header || `Column ${index + 1}`;

		return (
			<option key={index} value={index}>
				{columnName}
			</option>
		);
	};

	render() {
		const { label, value, headers } = this.props;

		return (
			<label className="col-select">
				<span className="col-select__label">{label}</span>
				<select value={value} onChange={this.onColumnSelect}>
					<option value={-1}>—</option>
					{headers.map(this.renderColumnOption)}
				</select>
			</label>
		);
	}
}

export default ColSelect;
